import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "retrieve-action-invocation-results"
    }}>{`Retrieve Action Invocation Results`}</h1>
    <p>{`The activation record contains information that helps you understand what happened: activation ID (the unique identifier), namespace and action name, logs (if any), response (a dictionary that contains the status, success, and result).`}</p>
    <h2 {...{
      "id": "activations-ttl"
    }}>{`Activations TTL`}</h2>
    <p>{`The activation TTL (Time To Live) is seven days. This is a system setting, not a user setting (it can't be changed by developers).`}</p>
    <p>{`Thus, if you don't see any activations or not seeing an activation you know that has happened, it could be that they happend more than 7 days ago.`}</p>
    <h2 {...{
      "id": "example"
    }}>{`Example`}</h2>
    <p>{`Assuming that you`}{`’`}{`ve invoked an action called `}<inlineCode parentName="p">{`hello`}</inlineCode>{`, this is how you retrieve the latest activations:`}</p>
    <p><inlineCode parentName="p">{`aio rt:activation:list`}</inlineCode></p>
    <p>{`The result will be a list of activation IDs (if any) and the action invoked for each:`}</p>
    <pre><code parentName="pre" {...{}}>{`e9932762894d4ccf932762894d6ccff4 hello            
c76dbe66e9b04ad5adbe66e9b06ad541 hello            
[]...]
`}</code></pre>
    <p>{`You can retrieve the whole activation record by running `}<inlineCode parentName="p">{`aio rt:activation:get <activation id>`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{}}>{`aio rt:activation:get e9932762894d4ccf932762894d6ccff4
ok: got activation e9932762894d4ccf932762894d6ccff4
{
    "namespace": "your-namespace",
    "name": "hello",
    "version": "0.0.20",
    "subject": "your-namespace",
    "activationId": "e9932762894d4ccf932762894d6ccff4",
    "start": 1542232412321,
    "end": 1542232412366,
    "duration": 45,
    "response": {
        "status": "success",
        "statusCode": 0,
        "success": true,
        "result": {
            "body": {
                "payload": {
                    "message": "hello world!"
                }
            },
            "statusCode": 200
        }
    },
    "logs": [],
    "annotations": [
        {
            "key": "path",
            "value": "your-namespace/hello"
        },
        {
            "key": "waitTime",
            "value": 23
        },
        {
            "key": "kind",
            "value": "nodejs:10-fat"
        },
        {
            "key": "limits",
            "value": {
                "logs": 10,
                "memory": 256,
                "timeout": 60000
            }
        },
        {
            "key": "initTime",
            "value": 40
        }
    ],
    "publish": false
}
`}</code></pre>
    <p>{`Or you can extract a specific part from the activation record:`}</p>
    <pre><code parentName="pre" {...{}}>{`// just the result
aio rt:activation:result <activation ID>

// just the logs
aio rt:activation:logs <activation ID>
`}</code></pre>
    <h2 {...{
      "id": "retrieving-activations-for-blocking-successful-calls"
    }}>{`Retrieving Activations for Blocking Successful Calls`}</h2>
    <p>{`At scale, when you run millions of activations in a day, it may be difficult to extract the activations that failed in order to debug them. To help with this task, the system skips persisting the activation that succeeded. `}</p>
    <p>{`The exceptions are asynchronous actions that are invoked in a non-blocking fashion. Their results are persisted regardless
so that you can extract the response of the action at a later time. `}</p>
    <p>{`You can still view the number of executions, please see the `}<a parentName="p" {...{
        "href": "https://github.com/AdobeDocs/adobeio-runtime/blob/master/guides/logging_monitoring.md"
      }}>{`Logging and Monitoring`}</a>{` section. `}</p>
    <p>{`However, during development it is important to have access to all activation results. You can enable this by setting in the request the extra logging header to `}<inlineCode parentName="p">{`on`}</inlineCode>{`: `}</p>
    <pre><code parentName="pre" {...{}}>{`X-OW-EXTRA-LOGGING: on
`}</code></pre>
    <blockquote>
      <p parentName="blockquote">{`It's not recommended to use the extra logging headers in the production environment as invocation performance can be impacted. `}</p>
    </blockquote>
    <h2 {...{
      "id": "retrieving-activations-for-non-blocking-calls"
    }}>{`Retrieving Activations for Non-blocking Calls`}</h2>
    <p>{`When you execute a non-blocking action (async action), the action returns immediately the activation ID. If you query for the result or logs before the action finished the execution you get an error:`}</p>
    <pre><code parentName="pre" {...{}}>{`aio rt:activation:get 1d24121f91384740a4121f91389740f0
error: Unable to get activation '1d24121f91384740a4121f91389740f0': The requested resource does not exist. (code myM2aaCufgIcnjnrbNIHztNmhL2HvFia)


aio rt:activation:logs c8c4f354c1824f2c84f354c182ef2cdb
error: Unable to get logs for activation 'c8c4f354c1824f2c84f354c182ef2cdb': The requested resource does not exist. (code nCPo4KRbYmvOTcwPQVfDJdrwtJpv1c3d)
`}</code></pre>
    <p>{`This should give you enough tools to debug your first actions. If you want to read more, take a look at the `}<a parentName="p" {...{
        "href": "../guides/logging_monitoring.md",
        "title": "Logging and Monitoring"
      }}>{`Logging and Monitoring`}</a>{` page.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      